import React, { FC, Fragment } from 'react'
import {
  Button,
  DrawerBody,
  DrawerCloseButton,
  DrawerFooter,
  DrawerHeader,
  Heading,
  Text,
  Stack,
} from '@chakra-ui/react'

import { Empty, Loader } from 'components'

import GambiarraFilterTags from 'InstitutionalManagement/components/SalaryFilterTags'
import CustomFormJobsiteCardToSelect from './components/CustomFormJobsiteCardToSelect'
import { useCustomFormJobsiteSelectionDrawerManager } from '../../contexts/CustomFormJobsiteSelectionDrawerManager/Provider'

type Props = {
  onClose: () => void
}

const SelectJobsiteOnCustomForm: FC<Props> = ({ onClose }) => {
  const { loadingJobsites, jobsites, setView, filter, setFilter } = useCustomFormJobsiteSelectionDrawerManager()

  return (
    <>
      <DrawerCloseButton />

      <DrawerHeader>
        <Text>Postos de trabalho disponíveis</Text>
        <Heading color="primary">Selecione um posto de trabalho</Heading>
      </DrawerHeader>

      <DrawerBody overflowY="auto">
        <GambiarraFilterTags px={4} pb={4} salaryFilter={filter} setSalaryFilter={setFilter} />

        {loadingJobsites ? (
          <Loader text={'Carregando postos de trabalho disponíveis'} />
        ) : (
          <Fragment>
            {jobsites.length > 0 ? (
              <Stack>
                {jobsites.map((jobsite) => (
                  <CustomFormJobsiteCardToSelect key={jobsite.id} jobsite={jobsite} onClose={onClose} />
                ))}
              </Stack>
            ) : (
              <Empty title={'Nenhum posto de trabalho encontrado'} description="Sua busca não retornou registros" />
            )}
          </Fragment>
        )}
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={() => setView('SEARCH_JOBSITE')}>
          Voltar
        </Button>

        <Button onClick={onClose}>Concluir</Button>
      </DrawerFooter>
    </>
  )
}

export default SelectJobsiteOnCustomForm
